import { render, staticRenderFns } from "./CurrentDateTime.vue?vue&type=template&id=11f98234&"
import script from "./CurrentDateTime.vue?vue&type=script&lang=ts&"
export * from "./CurrentDateTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports